import React from "react";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

export const SelectButton = ({
  label,
  obligatorily,
  error,
  disabled,
  onClick,
  text,
  icon,
  className = "",
  placeholder = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`w-full flex flex-col gap-1.5 ${className}`}>
      {label && (
        <label className="text-xs font-semibold text-gray-700 flex items-center gap-1">
          {label}
          {obligatorily && <span className="text-red-500 font-bold">*</span>}
        </label>
      )}
      <button
        type="button"
        disabled={disabled}
        onClick={onClick}
        className={`w-full flex items-center justify-between px-3.5 py-2.5 min-h-[44px] rounded-xl text-sm transition-all outline-none bg-white text-left ${
          disabled
            ? "opacity-50 cursor-not-allowed bg-gray-100 border border-gray-200"
            : error
            ? "border-2 border-red-500 bg-red-50/20 text-gray-900"
            : "border border-gray-200 hover:border-gray-300 focus:border-[#020637] focus:ring-2 focus:ring-[#020637]/10 text-gray-900"
        }`}
      >
        <div className="flex items-center gap-2.5 min-w-0 flex-1 truncate">
          {icon && (
            <img
              src={icon}
              alt=""
              className="w-5 h-5 object-contain rounded flex-shrink-0"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          )}
          <span
            className={`truncate ${
              placeholder ? "text-gray-400 font-normal" : "font-medium text-gray-900"
            }`}
          >
            {text}
          </span>
        </div>
        <ChevronDown className="w-4 h-4 text-gray-400 flex-shrink-0 ml-2" />
      </button>
      {error && (
        <span className="text-[11px] text-red-500 font-medium">
          {typeof error === "string"
            ? error
            : t("profile.fieldRequired", "This field is required")}
        </span>
      )}
    </div>
  );
};
